<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img17_1" src="images/img17_1.jpg"/></p>
<p class="caption"><em class="italic">Lewisham Cage.</em> <span class="small">London Borough of Lewisham</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08a_LEWISHAM_CHAPTER02.vue?4fc38049